import { render, staticRenderFns } from "./component-nav.vue?vue&type=template&id=3b0986b6&scoped=true&"
import script from "./component-nav.vue?vue&type=script&lang=ts&"
export * from "./component-nav.vue?vue&type=script&lang=ts&"
import style0 from "./component-nav.vue?vue&type=style&index=0&id=3b0986b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0986b6",
  null
  
)

export default component.exports